import LangEnum from '../../../lang/LangEnum';
import { handlerApiError } from '../../../lib/basicRepository';
import { findOrderConditions as onlineFindOrderConditions } from '../../../services/modules/orderCondition/orderCondition.repository';
import { FindOrderConditionParams } from '../../../services/modules/orderCondition/orderCondition.types';
import { GetOrderConditionDTO } from '../../orders/conditions/dtos/orderCondition.dto';
import { onlineOrderConditionRepository } from '../../orders/conditions/orderCondition.repository';
import { OrderConditionSubmitData } from '../../orders/conditions/orderCondition.types';
import { AvailabilityEnum } from '../../products/ProductTypes';
import { offlineOrdersRepository } from '../repositories/offlineOrders.repository';
import { useOfflineOrdersStore } from '../stores/offlineOrders/offlineOrders.store';
import { OfflineOrderTransformers } from '../transformers/OfflineOrder.transformers';
import { createApiSauceResponse } from '../utils/createApiSauceResponse.util';
import { notImplementedInOfflineError } from './utils/repository.offlineAdapters.utils';

const findOrderConditions: typeof onlineFindOrderConditions = async ({
  orderId,
}: FindOrderConditionParams) => {
  const offlineOrder = await offlineOrdersRepository.getById(orderId);
  if (!offlineOrder) {
    return createApiSauceResponse({
      ok: false,
    });
  }

  const productsWithDefinedAvailability = offlineOrder.products?.some(
    (product) => product.availability !== AvailabilityEnum.EMPTY,
  );

  return createApiSauceResponse({
    ok: true,
    data: productsWithDefinedAvailability
      ? [OfflineOrderTransformers.toGetOrderConditionDTO(offlineOrder)]
      : [],
  });
};

export const orderConditionRepositoryFromModulesOfflineAdapters: typeof onlineOrderConditionRepository =
  (orderId: string) => ({
    update: async ({ observation }: OrderConditionSubmitData) => {
      if (!observation) {
        return createApiSauceResponse({
          ok: false,
        });
      }

      try {
        const offlineOrdersStore = useOfflineOrdersStore.getState();

        const updatedOfflineOrder = await offlineOrdersStore.updateObservation(
          orderId,
          observation,
        );

        const updatedCondition =
          OfflineOrderTransformers.toGetOrderConditionDTO(updatedOfflineOrder);

        return handlerApiError(
          createApiSauceResponse<GetOrderConditionDTO, any>({
            ok: true,
            data: updatedCondition,
          }),
        );
      } catch (e) {
        console.error('orderConditionRepositoryFromModulesOfflineAdapters.update', e);
        return handlerApiError(
          createApiSauceResponse<GetOrderConditionDTO[], any>({
            ok: false,
            data: {
              message: 'error updating order condition',
              code: LangEnum.ORDER_ERROR_UPDATING_ORDER_CONDITIONS,
            },
          }),
        );
      }
    },
    create: () => notImplementedInOfflineError('create'),
    delete: () => notImplementedInOfflineError('delete'),
    find: () => notImplementedInOfflineError('find'),
    updateAll: () => notImplementedInOfflineError('updateAll'),
    getOne: () => notImplementedInOfflineError('getOne'),
    remove: () => notImplementedInOfflineError('remove'),
  });

export const orderConditionRepositoryOfflineAdapters = {
  findOrderConditions,
};
